import React from 'react';

/**
 * Use this context if you need to get the nodes inside of the modal wrapper,
 * that are located before/after the modal content.
 *
 * We use it in order to place nodes with `Portal`,
 * that need to be outside of the `ModalContent` tree,
 * but inside of the `ModalContainer` wrapper
 * (so it is inside of the ModalContainer's focus trap).
 */

var ModalWrapperContext = /*#__PURE__*/React.createContext({
  nodeBefore: /*#__PURE__*/React.createRef(),
  nodeAfter: /*#__PURE__*/React.createRef()
});

export { ModalWrapperContext };
